var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-filter',{attrs:{"title":_vm.menuTitle,"item-name":"Cases","missed-term":_vm.missedTerm,"filter":_vm.filter,"pagination":_vm.pagination,"status-options":_vm.statusOptions},on:{"changed":(e) => _vm.$emit('changed', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }